import React from "react"

import { Control } from "react-hook-form"

import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form"
import { Textarea } from "@/components/ui/textarea"

interface CommentsSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
}

const CommentsSection: React.FC<CommentsSectionProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="comments"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Comments</FormLabel>
          <FormControl>
            <Textarea placeholder="Enter comments" className="h-24 resize-none" {...field} />
          </FormControl>
        </FormItem>
      )}
    />
  )
}

export default CommentsSection
